import { Box, Button, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import Seperator from "../Seperator";
import styles from "./Navbar.module.css";
import SidebarData from "./Sidebar";
import { logout } from "../../utils/authHelpers";

const Navbar = () => {
  const location = useLocation();
  const [toggle, setToggle] = useState(true);
  const [title, setTitle] = useState("Dashboard");
  const [logoutDialog, setLogoutDialog] = useState(false);

  const hideChildData = () => setToggle((prev) => !prev);

  useEffect(() => {
    const path = location.pathname;
    const pathTitleMap = {
      "/dashboard": "Dashboard",

      "/worklist": "Work List",
      "/worklist/myworklist": "My Work List",
      "/worklist/carepreneur": "Carepreneur",
      "/worklist/hospital": "Hospital",

      "/profile": "Profile",

      "/settings": "Settings",
      "/settings/profile": "Profile",
      "/settings/services": "Services",
      "/settings/booking-categories": "Booking Categories",
      "/settings/care-reasons": "Care Reasons",
      "/settings/preferred-time": "Preferred Time",
      "/settings/urgencies": "Urgencies",
      "/settings/languages": "Languages",
      "/settings/prefered-zone": "Location",
      "/settings/status": "Lead Status",
      "/settings/googlemapkey": "Google Map Key",
      "/settings/availble-shifts": "Available-Shifts",
      "/settings/days-available": "Days-Available",
      "/settings/education-levels": "Education-Levels",
      "/settings/hospital-facilities": "Hospital Facility",
      "/settings/facility-service": "Facility Service",
      "/settings/states": "States",
      "/settings/districts": "Districts",
      "/settings/cities": "Cities",
      "/settings/co-ordinator": "Co-Ordinators",
      "/settings/managers": "Managers",
      "/settings/lead-source": "Lead-Source",
      "/settings/interaction-type": "Interaction-Type",
      "/settings/interaction-channel": "Interaction-Channel",
      "/settings/interaction-outcome": "Interaction-Outcome",
      "/settings/followupmode": "FollowUpMode",
      "/settings/resourcetype": "ResourceType",
      "/settings/assessment-type": "AssessmentType",
      "/settings/assessment-mode": "AssessmentMode",
      "/settings/risk-category": "RiskCategory",
      "/settings/resource-category": "ResourceCategory",
      "/settings/relations": "Relations",
      "/settings/tariffs": "Tariffs",
      "/settings/medical_equipments": "Medical Equipments",
      "/settings/systematic-categories": "Systematic Categories",
      "/settings/systematic-status-master": "Systematic Status",
      "/settings/Systematic Status-master": "System Review",
      "/settings/risk-categories": "Risk Categories",
      "/settings/risk-levels": "Risk Levels",
      "/settings/adl-categories": "ADL Categories",
      "/settings/adl-score": "ADL Choices",
      "/settings/vital-categories": "Vital Categories",
      "/settings/vital-choices": "Vital Choices",
      "/settings/comorbidity-master": "Comorbidity Master",
      "/settings/skill-level-master": "Skill Level Master",
      "/settings/medication-complexities": "Medication Complexities",
      "/settings/home-readiness": "Home Readiness",
      "/settings/scenario-categories": "Scenario Categories",
      "/settings/scenario-choices": "Scenario Choices",
      "/settings/physiotherapy-types": "Physiotherapy Types",
      "/settings/nursing-procedures": "Nursing Procedures",
      "/settings/clinical-stability-masters": "Clinical Stability Masters",
      "/settings/frequency-masters": "Frequency Masters",
      "/settings/specialities": "Speciality Master",
      "/settings/speciality-master": "Speciality Master",

      "/marketing/blog-categories": "Blog Categories",
      "/marketing/blog-posts": "Blog Posts",
      "/marketing/contacts": "Contacts",
      "/marketing/seo-url": "Seo-Url",
    };

    setTitle(pathTitleMap[path] || "Dashboard");
  }, [location.pathname]);

  const handleLogoutConfirm = () => {
    logout();
    localStorage.removeItem("activeNav");
    localStorage.removeItem("activeChildPath");
    localStorage.removeItem("carepreneur_id");
    window.location.href = "/login";
  };

  return (
    <div className={styles.dblayout}>
      <Box>
        <section className={styles.navbar}>
          <img
            src={require("../dashboard/images/Wihan Logo.png")}
            className={styles.logo}
            alt="logo"
            onClick={() => (window.location.href = "/")}
          />
          <Seperator direction="vertical" />
          <GiHamburgerMenu className={styles.hammenu} onClick={hideChildData} />
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>{title}</p>

          <Avatar
            alt="user"
            src={require("../images/avatar.png")}
            style={{ marginLeft: "auto" }}
          />
          <Button
            variant="contained"
            style={{ marginLeft: "10px" }}
            onClick={() => setLogoutDialog(true)}
          >
            Logout
          </Button>
        </section>
      </Box>

      <div className={styles.dbcontent}>
        <SidebarData toggle={toggle} />
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </div>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={logoutDialog}
        onClose={() => setLogoutDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            Are you sure you want to logout? Any unsaved changes will be lost.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => setLogoutDialog(false)}
            sx={{ borderRadius: 2, textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleLogoutConfirm}
            sx={{ borderRadius: 2, textTransform: "none" }}
          >
            Yes, Logout
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Navbar;